module.exports = __webpack_public_path__ + "static/media/resellers.c16b3db4.svg";